import { Pipe, PipeTransform } from '@angular/core';
import { Slot } from '@app/shared/forms/slot-form/slot.model';
import moment from 'moment';

@Pipe({
  name: 'slotsDuration',
})
export class SlotsDurationPipe implements PipeTransform {
  transform(slots: Partial<Slot>[]): string {
    if (!slots || slots.length === 0) {
      return '00:00';
    }
    const totalMinutes = slots.reduce((slotsSum, slot) => {
      if (slot.startTime && slot.endTime) {
        const start = moment(slot.startTime, 'HH:mm').diff(moment().startOf('day'), 'minutes');
        const end = moment(slot.endTime, 'HH:mm').diff(moment().startOf('day'), 'minutes');
        const duration = (end - start + 24 * 60) % (24 * 60); // Handle overnight shifts
        return slotsSum + duration;
      }
      return slotsSum;
    }, 0);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }
}
